import {http} from './config/config-receituario'

export default{
    listar:async(token,itens_pagina,pagina,filter)=>{
        if(itens_pagina && pagina){
            return  http.get('produtos',{
                headers:{
                    'Authorization':token
                },
                params: {
                    itens_pagina,
                    pagina,
                    filter,
                },
            }) 
        }else{
            return  http.get('produtos',{
                headers:{
                    'Authorization':token
                }
            })
        }
    },
    listarNotFilter:async(token,itens_pagina,pagina,filters = {})=>{
        if(itens_pagina && pagina){
            return  http.get('produtos/filter',{
                headers:{
                    'Authorization':token
                },
                params: {
                    take: itens_pagina,
                    page: pagina,
                    ...filters,
                },
            }) 
        }else{
            return  http.get('produtos',{
                headers:{
                    'Authorization':token
                }
            })
        }
    },
    salvar:(token, produto)=>{
        return http.post('produtos',produto,{
            headers:{
                'Authorization':token
            }
        })
    },
    uploadArquivo:(token, idProduto, tipo, arquivo)=>{
        const formData = new FormData()
        formData.append('arquivo', arquivo)
        formData.append('tipo', tipo)

        return http.post(`produtos/${idProduto}/arquivos`, formData, {
            headers:{
                'Authorization':token,
                'Content-Type':'multipart/form-data'
            }
        })
    },
    consultar:(token, idProduto)=>{
        return http.get(`produtos/id/${idProduto}`,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idProduto)=>{
        return http.delete('produtos/'+idProduto,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, produto)=>{
        return http.put('produtos/'+produto.id_produto,produto,{
            headers:{
                'Authorization':token
            }
        })
    }

}
